/* eslint-disable react/destructuring-assignment */

import { Field, FieldProps, FieldRenderProps } from 'react-final-form'
import DeepCardRadioGroup from 'components/ui/DeepCardRadioGroup'
import { OptionGroup, PossibleValue } from 'components/ui/DeepRadioGroup'

type CardRadioGroupProps<T extends PossibleValue> = {
  description?: string
  label: string
  optionGroups: OptionGroup<T>[]
  questionId?: string
  newDesign?: boolean
}

export type Props<T extends PossibleValue> = CardRadioGroupProps<T> & {
  name: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldProps?: Partial<FieldProps<any, any>>
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EMPTY_FIELD_PROPS: Partial<FieldProps<any, any>> = {}

function InnerFormDeepCardRadioGroup<T extends PossibleValue>({
  description,
  label,
  optionGroups,
  input,
  name,
  questionId = name,
  newDesign,
  meta: { touched, error: syncError, submitError }
}: FieldRenderProps<T, HTMLInputElement> & CardRadioGroupProps<T>) {
  const error = syncError || submitError
  const showError = (touched || submitError) && !!error
  return (
    <DeepCardRadioGroup<T>
      description={description}
      error={showError ? error : null}
      label={label}
      name={name}
      newDesign={newDesign}
      onChange={(value) => {
        input.onChange(value)
        input.onBlur()
      }}
      optionGroups={optionGroups}
      questionId={questionId}
      value={input.value}
    />
  )
}

export default function FormDeepCardRadioGroup<
  T extends PossibleValue = string
>({ name, fieldProps = EMPTY_FIELD_PROPS, ...innerProps }: Props<T>) {
  return (
    <Field<T, FieldRenderProps<T, HTMLInputElement>, HTMLInputElement>
      name={name}
      render={(props) => (
        <InnerFormDeepCardRadioGroup<T>
          {...props}
          {...innerProps}
          name={name}
        />
      )}
      {...fieldProps}
    />
  )
}
